export default __webpack_public_path__ + "static/media/default-monochrome-white.b79e8292.svg";